"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var HasuraService = require("../Hasura");
var BaseService = require("./DataServiceEndPoint");
var Network = require("../Network");
var isClass = function isClass(obj) {
  return typeof obj === "function" && typeof obj.prototype !== "undefined";
};

/**
 * Services to be injected.
 * @typedef {Object} Services
 * @property {Object} logger - Logger-like service, see the logger implementation
 * @property {Object} config - A ConfigurationManager-like service
 * @property {Object} auth - An AuthenticationService-like service
 * */

/**
 * Base class to define a data service that can be injected.
 * A data service exposes any amount of dedicated data fetching services that fetch, process and validate data from network sources
 * It provides an interface to add these leaf services using keys, and a way to fetch them using said keys.
 * All attached services should follow the interface provided by {@link BaseService}
 */
var BaseDataService = /*#__PURE__*/function () {
  /**
   * @param {Services} services - all service definitions to be consumed by this service and it's attached services
   */
  function BaseDataService() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      config = _ref.config,
      logger = _ref.logger,
      auth = _ref.auth;
    (0, _classCallCheck2["default"])(this, BaseDataService);
    (0, _defineProperty2["default"])(this, "_services", {});
    (0, _defineProperty2["default"])(this, "_config", null);
    (0, _defineProperty2["default"])(this, "_logger", null);
    (0, _defineProperty2["default"])(this, "_auth", null);
    (0, _defineProperty2["default"])(this, "_httpService", null);
    (0, _defineProperty2["default"])(this, "_hasuraService", null);
    if (!config || config.get("auth.useAuthService") && !auth) {
      throw new Error("Unable to initialize Data Service, please provide configuration object");
    }
    this._config = config;
    this._logger = logger;
    this._auth = auth;
    this._hasuraService = new HasuraService({
      config: config,
      webSocket: true,
      auth: auth
    });
    this._httpService = Network.getInstance();
    this._httpService.setServices({
      config: config,
      logger: logger,
      auth: auth
    }).initialize();
  }

  /**
   * Attaches a service to the service map, it relies on a unique key which may come from the following sources in this exact order:
   * - The override key provided as a second parameter to this function
   * - A key defined in the object instance being provided to the service
   * - A static key defined in the class definition of the service
   * @param {BaseService | () => BaseService} Service
   * @param {String?} key
   */
  return (0, _createClass2["default"])(BaseDataService, [{
    key: "attach",
    value: function attach(Service) {
      var _ref2, _Service$constructor;
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _key = (_ref2 = key !== null && key !== void 0 ? key : Service.key) !== null && _ref2 !== void 0 ? _ref2 : (_Service$constructor = Service.constructor) === null || _Service$constructor === void 0 ? void 0 : _Service$constructor.key;
      if (this._services[_key]) {
        throw new Error("Key ".concat(_key, " is invalid, it's either empty or already defined"));
      }
      var isValid = isClass(Service) || Service instanceof BaseService;
      if (!isValid) {
        throw new Error("Provided service is invalid, provide a class or an instance of a class that extends BaseService");
      }
      this._services[_key] = isClass(Service) ? new Service({
        config: this._config,
        logger: this._logger,
        auth: this._auth,
        httpService: this._httpService,
        hasuraService: this._hasuraService
      }) : Service;
    }

    /**
     * Utility method to attach multiple services in one function call, keep in mind that the key override here is not available
     * @param {(BaseService | () => BaseService)[]} services
     */
  }, {
    key: "attachAll",
    value: function attachAll(services) {
      var _iterator = _createForOfIteratorHelper(services),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var service = _step.value;
          this.attach(service);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * Removes an attached service
     * @param {String} key
     */
  }, {
    key: "remove",
    value: function remove(key) {
      delete this._services[key];
    }

    /**
     * Gets a service
     * @param {String} key
     * @returns {BaseService | undefined}
     */
  }, {
    key: "get",
    value: function get(key) {
      return this._services[key];
    }
  }]);
}();
module.exports = BaseDataService;